import { App } from './app.ts';
import { GAME_NAME } from './config.ts';
import { PixiRenderer } from './render/pixi/scene.ts';
import { loadFolderAtlas, type ArtLoadReport } from './render/pixi/textures.ts';
import { createSim, parseBoard } from './sim/index.ts';

async function boot(): Promise<void> {
  document.title = GAME_NAME;
  const canvas = document.getElementById('game') as HTMLCanvasElement;
  const overlay = document.getElementById('overlay') as HTMLDivElement;
  // Real art: 3x on dense screens, 2x otherwise. A single-file build inlines the 2x set as data URIs.
  const inline = (window as unknown as { __ART?: Record<string, string> }).__ART;
  const scale = inline ? 2 : (window.devicePixelRatio || 1) >= 2.5 ? 3 : 2;
  overlay.hidden = false;
  overlay.innerHTML = `<div class="panel"><h1>${GAME_NAME}</h1><p id="boot-status">loading art…</p></div>`;
  const status = document.getElementById('boot-status')!;
  const report: ArtLoadReport = { requested: 0, loaded: 0, failed: [], firstError: null, ms: 0, source: 'none' };
  const art = await loadFolderAtlas('./art', scale, inline, (n, total) => { status.textContent = `loading art ${n}/${total}`; }, report);
  const renderer = await PixiRenderer.create(canvas, art);
  const app = new App(canvas, overlay, renderer, report);
  app.start();
  // Dev hooks for scripted captures and console experiments.
  (window as unknown as { __app: App; __sim: unknown }).__app = app;
  (window as unknown as { __sim: unknown }).__sim = { createSim, parseBoard };
}

boot().catch((e) => {
  document.body.innerHTML = `<pre style="color:#f88;padding:16px">Failed to start renderer: ${String(e)}</pre>`;
});
